export default "__VITE_ASSET__D$l_Lrtc__"